<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="导入记录"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="800px"
  >
    <div class="dialog__container">
      <div class="infinite-list" v-loading="tableLoading"
        v-infinite-scroll="load" :infinite-scroll-delay="500" style="overflow:auto; max-height:400px">
        <el-table
        :data="list"
        border
        style="width: 100%"
        >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="createTime" width="150" show-overflow-tooltip label="导入时间"></el-table-column>
        <el-table-column prop="updateTime" width="150" show-overflow-tooltip label="完成时间"></el-table-column>
        <el-table-column prop="importTypeName" width="150" show-overflow-tooltip label="导入类型"></el-table-column>
        <el-table-column prop="importFileName" width="200" show-overflow-tooltip label="文件名称"></el-table-column>
        <el-table-column prop="importStatusName" show-overflow-tooltip label="导入状态"></el-table-column>
        <el-table-column prop="importSuccessNum" show-overflow-tooltip label="成功数"></el-table-column>
        <el-table-column prop="importFailNum" show-overflow-tooltip label="失败数"></el-table-column>
        <el-table-column prop="createUserName" show-overflow-tooltip label="操作用户"></el-table-column>
        <el-table-column prop="importErrorJson" width="200" show-overflow-tooltip label="导入结果"></el-table-column>
      </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { importList } from "@/api/Sys";
export default {
  data() {
    return {
      list: [],
      tableLoading: false,
      pageIndex: 1,
      pageSize: 20,
      total: 1,
      getListParams: {
        pageIndex: 0,
        pageSize: 20,
      }
    }
  },
  created() {

  },
  methods: {
    handleBeforeClose(done) {
      this.$emit('cancel')
      done()
    },
    handleCancel() {
      this.$emit('cancel')
    },
    async handleConfirm() {
      this.$emit('cancel')
    },
    async load () {
      if (this.list.length < this.total) {
        this.getListParams.pageIndex += 1;
        const res = await importList(this.getListParams);
        if (res.code === 200) {
          this.list = res.data.list
          this.total = res.data.total
        }
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ContractManagement/components/Records.vue